import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "permission-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "permission-tabel-data"
};
const _hoisted_4 = {
  key: 1,
  class: "table-empty",
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
};
import { ref, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import permissionDialog from "./components/permission-dialog.vue";
import { storeToRefs } from "pinia";
import useRoleStore from "@/store/modules/role";
import { addLoading } from "@/utils/element-method";
import { deletePermissionApi } from "@/service/modules/role";
import { ElMessage, ElMessageBox } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'permission',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const permissionDialogVisible = ref(false);
    const permissionDialogType = ref("add");
    let permissionDialogData = {};
    const roleStore = useRoleStore();
    const {
      allPermissionList
    } = storeToRefs(roleStore);
    initData();
    function initData() {
      permissionDialogVisible.value = false;
      const loadingInstance = addLoading(".permission-tabel-data");
      roleStore.getAllPermissionListAction().then(() => {
        loadingInstance.close();
      }).catch(() => {
        loadingInstance.close();
      });
    }
    function handleTableItem(dialogType, itemData) {
      permissionDialogType.value = dialogType;
      permissionDialogData = itemData;
      permissionDialogVisible.value = true;
    }
    function deletePermissioTableItem(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deletePermissionApi(id);
          ElMessage.success("删除成功");
          initData();
        } catch {}
      }).catch(() => {});
    }
    function handlePermissionDialog() {
      permissionDialogType.value = "add";
      permissionDialogData = {};
      permissionDialogVisible.value = true;
    }
    function closePermissionDialog() {
      permissionDialogVisible.value = false;
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createTextVNode(" 权限管理 ")), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handlePermissionDialog,
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_unref(allPermissionList).length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _unref(allPermissionList),
        "default-expand-all": "",
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        "row-key": "id"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "title",
          label: "菜单名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "type",
          label: "类型",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [scope.row.type === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "info"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("菜单")])),
            _: 1
          })) : _createCommentVNode("", true), scope.row.type === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("路由")])),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "e_name",
          label: "路由路径",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "component",
          label: "组件路径",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "isShow",
          label: "是否显示",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [scope.row.isShow === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "danger"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("隐藏")])),
            _: 1
          })) : _createCommentVNode("", true), scope.row.isShow === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("显示")])),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleTableItem('addSubset', scope.row)
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("添加")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "warning",
            onClick: $event => handleTableItem('edit', scope.row)
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deletePermissioTableItem(scope.row.id)
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[9] || (_cache[9] = [_createElementVNode("img", {
        class: "no-data",
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("div", {
        class: "empty-text"
      }, "暂无数据", -1)])))]), _createVNode(permissionDialog, {
        "dialog-type": permissionDialogType.value,
        "item-data": _unref(permissionDialogData),
        "dialog-visible": permissionDialogVisible.value,
        onResData: initData,
        onCloseDialog: closePermissionDialog
      }, null, 8, ["dialog-type", "item-data", "dialog-visible"])]);
    };
  }
});